import {
  MarkAllNotificationsReadResponse,
  MarkAllNotificationsReadResponseDto,
  Notification,
  NotificationDto,
  NotificationResponse,
  NotificationResponseDto,
} from "./notification";
import { RealtimeNotification } from "../../ws/realtimeNotification";

/**
 * Adapts a REST notification DTO to the frontend notification model.
 * @param value The REST notification DTO.
 * @returns The frontend notification.
 */
export function parseRestNotification(value: NotificationDto): Notification {
  return value;
}

/**
 * Adapts a realtime notification to the frontend notification model.
 * @param value The realtime notification.
 * @returns The frontend notification without realtime-only metadata.
 */
export function parseRealtimeNotification(value: RealtimeNotification): Notification {
  return {
    id: value.id,
    category: value.category,
    severity: value.severity,
    type: value.type,
    createdAt: value.createdAt,
    readStatus: value.readStatus,
    data: value.data,
  } as Notification;
}

/**
 * Adapts a paginated notification DTO response.
 * @param value The REST response DTO.
 * @returns The frontend notification response.
 */
export function parseNotificationResponse(value: NotificationResponseDto): NotificationResponse {
  return {
    hasNext: value.hasNext,
    totalPages: value.totalPages,
    totalNotifications: value.totalNotifications,
    totalUnreadCount: value.totalUnreadCount,
    notifications: value.notifications.map(parseRestNotification),
  };
}

/**
 * Adapts the DTO response for marking all notifications as read.
 * @param value The REST response DTO.
 * @returns The frontend mark-all response.
 */
export function parseMarkAllNotificationsReadResponse(
  value: MarkAllNotificationsReadResponseDto
): MarkAllNotificationsReadResponse {
  return {
    message: value.message,
    notifications: value.notifications.map(parseRestNotification),
  };
}
